export const DATE_TIME = {
  // ISO 8601 Formats
  ISO_DATE: "YYYY-MM-DD",
  ISO_DATETIME: "YYYY-MM-DDTHH:mm:ssZ",
  ISO_DATETIME_MILLISECONDS: "YYYY-MM-DDTHH:mm:ss.SSSZ",

  // Short Formats
  SHORT_DATE: "MM/DD/YYYY",
  SHORT_DATE_TIME: "YYYY-MM-DD HH:mm",

  // Time Only
  TIME: "HH:mm:ss",
  TIME_12HR: "hh:mm A",

  // Full Date and Time
  FULL_DATETIME: "YYYY-MM-DD HH:mm:ss",
  FULL_DATETIME_WITH_DAY: "dddd, MMMM Do YYYY, h:mm:ss A",
  RELATIVE_TIME: "fromNow", // Will use `.fromNow()` for relative time

  // Day and Month Formats
  DAY: "dddd", // Full Day of the Week
  SHORT_DAY: "ddd", // Short Day of the Week
  MONTH: "MMMM", // Full Month Name
  SHORT_MONTH: "MMM", // Short Month Name

  // Year Formats
  YEAR: "YYYY", // Full Year
  SHORT_YEAR: "YY", // Short Year

  // Timezone Formats
  TIMEZONE: "Z", // UTC Offset (+00:00 or -08:00)
  TIMEZONE_ABBR: "z", // Timezone abbreviation (e.g., PST)

  // Custom Formats
  CUSTOM_DATE: "DD-MM-YYYY", // Custom date format
  CUSTOM_DATETIME: "MMMM Do YYYY, h:mm:ss a", // Full date and time with 12-hour format
  G_DATE_TIME_FORMAT: "DD/MM/YYYY hh:mm:ss A Z"
};

export const csvModelFileTemplates = {
  twoColumns: "https://storage.googleapis.com/meii-process-data/mei_feature_admin_files/indianfood.csv",
  threeColumns: "https://storage.googleapis.com/meii-process-data/mei_feature_admin_files/template3.csv"
}

export const REGEX_PATTERNS = {
  alphaNumericWithSpacesRegex: /^[a-zA-Z0-9\s]*$/,
   numberWithDotshostRegex: /^(?:(?:[a-zA-Z0-9-]+\.)+[cC][oO][mM]|(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3})$/,
  onlyNumberportRegex : /^\d+$/,
}

export const setSessionActiveCard = (value: string): void => {
    sessionStorage.setItem("activeCard", value);
};

export const getInitialActiveCard = (): string => {
  if (typeof window !== "undefined") {
    const currentPath = window.location.pathname;

    if (currentPath === "/dashboard") {
      sessionStorage.setItem("activeCard", "");
      return "";
    }

    const storedCard = sessionStorage.getItem("activeCard");
    return storedCard || "";
  }

  return "";
};